import useEventPrice from "@QUERIES/prdt/event/useEventPrice";
import {useEffect} from "react";
import {PageProps} from "./types";

const TaggingGTM = (props: PageProps) => {
	// 아래는 Google tag manager 관련
	const eventPriceFetch = useEventPrice(props.query.evCd);
	const eventPrice = eventPriceFetch.data?.body;

	useEffect(() => {
		if (!eventPrice) return;
		try {
			dataLayer.push({
				event: "addToCart",
				ecommerce: {
					currencyCode: "KRW",
					add: {
						products: [
							{
								name: `${props.eventDetail.evNm}`,
								id: `${props.goodsDetail.goodsCd}`,
								price: `${Number(eventPrice.adtPrice + eventPrice.bafAdtCost + eventPrice.airTaxAdtCost)}`,
								category: `${props.query.menu}`,
							},
						],
					},
				},
			});
		} catch (e) {
			console.log(e);
		}
	}, [eventPrice]);

	return <></>;
};

export default TaggingGTM;
